"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var FollowPath_1 = require('gdx-ai/lib/steer/behaviors/FollowPath');
var LinePath_1 = require('gdx-ai/lib/steer/utils/paths/LinePath');
var CentralRayWithWhiskersConfiguration_1 = require('gdx-ai/lib/steer/utils/rays/CentralRayWithWhiskersConfiguration');
var RaycastObstacleAvoidance_1 = require('gdx-ai/lib/steer/behaviors/RaycastObstacleAvoidance');
var PrioritySteering_1 = require('gdx-ai/lib/steer/behaviors/PrioritySteering');
var CollisionAvoidance_1 = require('gdx-ai/lib/steer/behaviors/CollisionAvoidance');
var RadiusProximity_1 = require('gdx-ai/lib/steer/proximities/RadiusProximity');
var RaycastCollisionDetector3D_1 = require('./RaycastCollisionDetector3D');
var Command_1 = require('./Command');
var degreesToRadians = Math.PI / 180;
var MoveCommand = (function (_super) {
    __extends(MoveCommand, _super);
    function MoveCommand(character, path, characters, getTickID, raycast) {
        _super.call(this);
        this.character = character;
        var rayConfiguration = new CentralRayWithWhiskersConfiguration_1.default(character, 2.5, 1, 35 * degreesToRadians);
        var raycastCollisionDetector = new RaycastCollisionDetector3D_1.default(raycast);
        var raycastObstacleAvoidanceSB = new RaycastObstacleAvoidance_1.default(character, rayConfiguration, raycastCollisionDetector, 40);
        var proximity = new RadiusProximity_1.default(character, characters, character.getBoundingRadius() * 4, getTickID);
        var collisionAvoidanceSB = new CollisionAvoidance_1.default(character, proximity);
        this.linePath = new LinePath_1.default(path, true);
        this.followPathSB = new FollowPath_1.default(character, this.linePath, 3)
            .setTimeToTarget(0.1) //
            .setArrivalTolerance(3) //
            .setDecelerationRadius(0);
        this.prioritySteeringSB = new PrioritySteering_1.default(character, 0.0001)
            .add(raycastObstacleAvoidanceSB)
            .add(collisionAvoidanceSB)
            .add(this.followPathSB);
    }
    MoveCommand.prototype.getSteeringBehavior = function () {
        return this.prioritySteeringSB;
    };
    MoveCommand.prototype.update = function () {
        // Once arrived at an extremity of the path we want to go the other way around
        var extremity = this.followPathSB.getPathOffset() >= 0
            ? this.linePath.getEndPoint() : this.linePath.getStartPoint();
        var tolerance = this.followPathSB.getArrivalTolerance();
        if (this.character.getPosition().dst2(extremity) < tolerance * tolerance) {
            this.resolve();
            return false;
        }
        return true;
    };
    return MoveCommand;
}(Command_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MoveCommand;
//# sourceMappingURL=MoveCommand.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/controls/CommandControl/commands/MoveCommand.js
 ** module id = 929
 ** module chunks = 0
 **/